import React, { memo, useEffect, useMemo, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { Advice } from '@Sage/hoi-poi-ui';

import BoolField from 'containers/components/Fields/Bool';
import { getLiteral } from 'utils/getLiteral';

const NotifyAllParticipants = memo(({ field, data, changeField }) => {
    const nylasConfig = useSelector((state) => state?.config?.nylas);

    const [disabled, setDisabled] = useState();
    const initialValue = useRef(data?.notifyAllParticipants);
    const { id, label, isBulkAction } = field;

    useEffect(() => {
        if (nylasConfig?.account?.status === 4 && nylasConfig?.calendar?.enabled) {
            return setDisabled(false);
        } else return setDisabled(true);
    }, [nylasConfig?.account?.status, nylasConfig?.calendar?.enabled]);

    const isReadOnly = useMemo(() => {
        if (data?.id && initialValue.current) return true;
        return false;
    }, [data]);

    const adviceText = useMemo(() => {
        if (isReadOnly) return getLiteral('label_calendar_send_invites_advice_sent');
        return getLiteral('label_calendar_send_invites_advice');
    }, [isReadOnly]);

    if (
        isBulkAction ||
        (!data?.contact?.length && !data?.usersAttendees?.length && !data?.externalAttendees) ||
        disabled
    ) {
        return null;
    }

    return (
        <div className="notify-all-participants-field-container">
            <BoolField
                label={label}
                isBulkAction={isBulkAction}
                value={data?.notifyAllParticipants}
                onChange={changeField(id)}
                readOnly={isReadOnly}
            />
            <Advice type="info" defaultCollapsed={false}>
                {adviceText}
            </Advice>
        </div>
    );
});

NotifyAllParticipants.displayName = 'NotifyAllParticipants';

export default NotifyAllParticipants;
